import React, { forwardRef, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { MDBAlert, MDBBtn, MDBModalFooter, MDBSpinner, MDBSelect, MDBCheckbox } from "mdb-react-ui-kit";
import { deleteBillingGroups, deleteBillingInfo } from "../../../apiclients/streamsapi_bridge.js";

const DeleteBilling = forwardRef((props, ref) => {
    const [internalError, setInternalError] = useState(false);
    const { t, i18n } = useTranslation();
    const [invoiceGroupList, setinvoiceGroupList] = useState([]);
    const [deleteMessage, setdeleteMessage] = useState("");
    const [deleteInvoiceMessage, setdeleteInvoiceMessage] = useState("");
    const [checkedItems, setCheckedItems] = useState([]);
    const [statementGroups, setstatementGroups] = useState([]);
    const [invoicegroup, setinvoicegroup] = useState(null);
    // const [statmentgrp, setstatmentgrp] = useState([]);
    const [selectAll, setselectAll] = useState(false);

    useEffect(() => {
        if (Object.entries(props?.deleteGroupDependency)?.length > 0) {
            setinvoiceGroupList((props?.deleteGroupDependency?.invoice_groups ?? []).map((group) => ({ text: group.billing_group_name, value: group.billing_group_id })));
            setdeleteMessage(props?.deleteGroupDependency?.messsage ?? "");
            setdeleteInvoiceMessage(props?.deleteGroupDependency?.delete_inv_message ?? "");
            const statementArray = Object.entries(props?.deleteGroupDependency?.statement_groups ?? []).map(([id, name]) => ({
                id,
                name
              }));
            setstatementGroups(statementArray ?? []);

        }


    }, [props.deleteGroupDependency])

    async function removeThisGroup(e) {
        try {
            console.log("Delete billling group popup called " + JSON.stringify(props?.billinggrpInfo?.billing_group_id));
            setInternalError(false);
            props.setIsloading(true);
            let update = {
                reqid: 141,
                siteid: JSON.parse(sessionStorage.getItem("admin_session")).siteid,
                bgrp_id: parseInt(props?.billinggrpInfo?.billing_group_id),
                confirm: true,
            }
            if (invoicegroup) {
                update.transfer_bg_id = invoicegroup;
            }
            if (checkedItems && checkedItems.length > 0) {
                update.checked_stmt_grps = [...checkedItems];
            }
            let deleteGrpReponse = await deleteBillingInfo(update);
            setTimeout(() => { props.setIsloading(false) }, 1000);
            let delInfo = await deleteGrpReponse.json();
            if (deleteGrpReponse.status == 200) {
                if (delInfo.status == 'success') {
                    sessionStorage.setItem("billinggroup_updated", true);
                    localStorage.setItem("s_message", delInfo.message);
                } else {
                    localStorage.setItem("f_message", delInfo.message);
                }
            } else if (delInfo.status == 400) {
                localStorage.setItem("f_message", delInfo?.message?.errors?.[0]?.message ?? delInfo?.message);
            } else if (delInfo.status == 500) {
                setInternalError(true);
            } else {
                localStorage.setItem("f_message", delInfo.message);
            }
            window.location.href = "/billinglanding";
            props.onClose();
        } catch (e) {
            console.log(`Unable to process Request :Internal server Error:!`);
            setInternalError(true);
        }
    }

    const handleSelectAll = (event) => {
        const { value, checked } = event.target;
        setCheckedItems(statementGroups && statementGroups.length > 0 && statementGroups.map((item) => checked ? parseInt(item.value) : []));
        setselectAll(checked);

    }

    const handleChange = (event) => {
        const { value, checked } = event.target;
        const updatedItems = checked ? [...checkedItems, parseInt(value)] : checkedItems.filter((item) => parseInt(item) !== parseInt(value));
        setCheckedItems(updatedItems);
        setselectAll(statementGroups.every((item) => updatedItems.includes(item.value)));
    };
    return (
        <>
            {internalError && (<MDBAlert
                open
                className="alert-center"
                color="danger"
                autohide
                position="bottom-right"
                delay={5000}
            >Internal Server Error</MDBAlert>)}

            <>
                {deleteMessage ? (
                    <p
                        dangerouslySetInnerHTML={{
                            __html: deleteMessage,
                        }}
                    />
                ) : (
                    <p>{t("RemoveBillingGrouptxt")}</p>
                )}
                {invoiceGroupList && invoiceGroupList.length > 0 && (
                    <div className="d-flex align-items-center mt-3">
                        <p className="pe-3">
                            Invoice Billing Groups :
                        </p>
                        <MDBSelect
                            data={[{ text: "--Select Group--", value: -1 },
                            ...invoiceGroupList,
                            ]}
                            value={invoicegroup}
                            onChange={(e) => setinvoicegroup(parseInt(e.value))}
                        />
                    </div>
                )}
                {deleteInvoiceMessage ? (
                    <>
                        <p
                            dangerouslySetInnerHTML={{
                                __html: deleteInvoiceMessage,
                            }}
                        />
                        {statementGroups && statementGroups.length > 0 && (
                        <MDBCheckbox
                            key={1}
                            name='checkboxGroup'
                            value={1}
                            label="Select All"
                            checked={selectAll}
                            id={`checkbox_${1}`}
                            onChange={handleSelectAll}
                        />
                        )}
                        {statementGroups && statementGroups.length > 0 && statementGroups.map((option, index) => (
                            <MDBCheckbox
                                key={index}
                                name='checkboxGroup'
                                value={option.id}
                                label={option.name}
                                checked={checkedItems.includes(parseInt(option.id))}
                                id={`checkbox${option}`}
                                onChange={handleChange}
                            />
                        ))}
                    </>
                ) : (
                    <p></p>
                )}
                <div style={{ display: "none" }}>
                    <button ref={ref} onClick={(e) => {
                        e.preventDefault();
                        removeThisGroup(e)

                    }}>
                        {t("okay")}</button>
                </div>
            </>

        </>
    );
});

export default DeleteBilling;
